import React, { useState } from "react";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { IconButton, Tooltip } from "@mui/material";
import {
  GridPreferencePanelsValue,
  GridToolbarContainer,
  gridPreferencePanelStateSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

// Single show/hide-columns control for the approvals grids, used instead of
// the per-header 3-dot menu (disableColumnMenu) so there's one place for it.
// Mirrors GridToolbarColumnsButton's toggle, with a gear icon.
// setAnchorEl hands the gear button to the grid (panel.anchorEl) so the
// panel opens under it instead of at the grid's left edge.
const ColumnsToolbar = ({ setAnchorEl }) => {
  const apiRef = useGridApiContext();
  const { open, openedPanelValue } = useGridSelector(apiRef, gridPreferencePanelStateSelector);

  const toggleColumns = () => {
    if (open && openedPanelValue === GridPreferencePanelsValue.columns) {
      apiRef.current.hidePreferences();
    } else {
      apiRef.current.showPreferences(GridPreferencePanelsValue.columns);
    }
  };

  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end", minHeight: 36, px: 1 }}>
      <Tooltip title="Show / hide columns">
        <IconButton
          ref={setAnchorEl}
          size="small"
          aria-label="Show or hide columns"
          onClick={toggleColumns}
          sx={{ color: "#555" }}
        >
          <SettingsOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </GridToolbarContainer>
  );
};

// Gear-icon show/hide columns for plain grids: replaces the per-header menu and
// filter with one toolbar button. Spread the returned grid props onto <DataGrid>
// and merge `components` (Toolbar) with any existing ones.
export const useColumnsToolbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  return {
    components: { Toolbar: ColumnsToolbar },
    componentsProps: {
      toolbar: { setAnchorEl },
      panel: { anchorEl, placement: "bottom-end" },
    },
    disableColumnMenu: true,
    disableColumnFilter: true,
  };
};

export default ColumnsToolbar;
